// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px","article_tile_grid_root":"fas_article_tile_grid_root"};